import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    topPartner: '',
    topPartnerList: [],
    topChannelList: [],
  },
  mutations: {
    setTopPartner(state, data) {
      state.topPartner = data;
    },
    setTopPartnerList(state, data) {
      state.topPartnerList = data.slice();
    },
    setTopChannelList(state, data) {
      console.log('data',data);
      state.topChannelList = data;
    },
  },
  getters: {
    filterTopPartnerList: (state) =>
      state.topPartnerList.map((item) => {
        return {id:item.id,channelUserId:item.channelUserId};
      }),
  },
  actions: {
    getTopPartner({ commit }, data) {
      api.getTopPartner(data).then((res) => {
        commit("setTopPartnerList", res.data.list);
      });
    },
    getTopChannelList({ commit }, data) {
     return api.getTopChannelList(data).then((res) => {
      console.log('sssssssssss',res);
        commit("setTopChannelList", res.data);
        return res
      });
    },
  },
};
appStore.registerModule("topPartner", store);
